import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";

var _class, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "6fda6xphClHcKtEapFhheIK", "AdChuanYin", undefined);

//@ts-nocheck
import { _decorator } from "cc";
import { E_ADEventType } from "../../EnumBase";
import AdEvent from "../AdEvent";
var ccclass = _decorator.ccclass;

var AdChuanYin = ccclass(_class = (_temp = /*#__PURE__*/function () {
  function AdChuanYin() {
    _defineProperty(this, "_bannerId", "503498176");

    _defineProperty(this, "_interstitialId", "194723805");

    _defineProperty(this, "_videoId", "327981064");

    _defineProperty(this, "bannerLoaded", false);

    _defineProperty(this, "interstitialAdLoaded", false);

    _defineProperty(this, "videoAdLoaded", false);

    _defineProperty(this, "isBannering", false);
  }

  var _proto = AdChuanYin.prototype;

  _proto.init = function init() {
    console.log(".adChuanYin.init.");
    window["adInit"]({
      banner_id: this._bannerId,
      //需要展示时 填写
      interstitial_id: this._interstitialId,
      //需要展示时 填写
      reward_id: this._videoId,
      //需要展示时 填写
      debug_mode: true,
      // = true时， 为测试广告   = false 时，为正式包

      /**
       * 当debug_mode为false时输入，又想测试需要输入，否则当大量请求或点击时，可能会被封号 
       * 获取方式： android开发日志环境，过滤 ： tag = Ads
       */
      test_device_id: "519B8E5DF9D07E5A897EA3B5766EE1CB",
      banner_location: 2,
      // banner 展示位置， 1 = 顶部   2 = 底部
      success: this.onInit.bind(this)
    });
  };

  _proto.onInit = function onInit(res) {
    this.bannerLoaded = true;
    this.interstitialAdLoaded = true;
    this.videoAdLoaded = true;
    AdEvent.I.handleEvent(E_ADEventType.banner_loadOver);
    console.log("ad chuanyin init succ");
  } // 创建Banner广告 创建一次即可，自动刷新广告
  // 参数
  //   adId: string 广告序号ID 游戏自定义
  //   bannerAdId: string Banner广告ID 需后台申请
  //   position: int 广告位置 1 屏幕顶部 2 屏幕底部
  ;

  _proto.createBannerAd = function createBannerAd() {};

  _proto.showBannerAd = function showBannerAd() {
    if (this.bannerLoaded) {
      //Object.keys(this._banner).length &&
      window["adShow"]({
        /**
         * 1: banner
         * 2: interstitialIs
         * 3: video
         */
        ad_type: 1,
        success: function success(res) {
          console.log("banner show succ, res = ", res);
        },
        fail: function fail(res) {
          console.log("banner show fail, res = ", res);
        }
      });
    } else {
      console.log('this._banner 未加载成功');
    }
  };

  _proto.hideBannerAd = function hideBannerAd() {};

  _proto.createInterstitialAd = function createInterstitialAd() {};

  _proto.showInterstitialAd = function showInterstitialAd() {
    if (this.interstitialAdLoaded) {
      window["adShow"]({
        /**
         * 1: banner
         * 2: interstitialIs
         * 3: video
         */
        ad_type: 2,
        success: function success(res) {
          console.log("intersittial show succ", res);

          if (res == 10001) {
            AdEvent.I.handleEvent(E_ADEventType.interstitial_showOver);
          }
        },
        fail: function fail(res) {
          console.log("intersittial show fail", res);
          AdEvent.I.handleEvent(E_ADEventType.interstitial_showFail);
        }
      });
    } else {
      console.log("this._interstitialAd 广告未加载成功");
    }
  } // 创建激励视频广告 展示一次创建一次
  // 参数
  //   adId: string 广告序号ID 游戏自定义
  //   videoAdId: string 视频广告ID 需后台申请
  //   screenOrientation: int 广告类型 1 横屏 2 竖屏
  ;

  _proto.createRewardedVideoAd = function createRewardedVideoAd() {};

  _proto.showRewardedVideoAd = function showRewardedVideoAd() {
    if (this.videoAdLoaded) {
      window["adShow"]({
        /**
         * 1: banner
         * 2: interstitialIs
         * 3: video
         */
        ad_type: 3,
        success: function success(res) {
          console.log("video show succ res = ", res);

          if (res == 10002) {
            console.log("handleSucc");
            AdEvent.I.handleEvent(E_ADEventType.video_showOver);
          }
        },
        fail: function fail(res) {
          console.log("video show fail res = ", res);
          AdEvent.I.handleEvent(E_ADEventType.video_showFail);
        }
      });
    } else {
      console.log("rewardedvideoAd 视频广告未加载成功");
    }
  };

  return AdChuanYin;
}(), _temp)) || _class;

export { AdChuanYin as default };

_cclegacy._RF.pop();